import './SidebarMenu.scss';
import EventIcon from "@mui/icons-material/Event";
import BookIcon from "@mui/icons-material/Book";
import MessageIcon from "@mui/icons-material/Message";
import { useNavigate,useLocation } from 'react-router-dom';
import { isMobileApp } from '../../../helpers/helpers';
export const SidebarMenu = (props: any) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { sidebarRouteData, currentCourse, className , iconSize } = props;
    const { id } = sidebarRouteData;

    const isActive = (btnName: string) => {
        let result = 'item py-md-4 px-md-3 py-3 px-1 d-flex align-items-center';
        const path = location.pathname
        
        switch (btnName) {
            case 'timeline':
                const tactive = path.indexOf('/timeline/');
                if (tactive > -1)
                    result += ' active';
                break;
            case 'library':
                const lactive = path.indexOf('/library/');
                if (lactive > -1)
                    result += ' active';
                break;
            case 'discussion':
                const dactive = path.indexOf('/discussion/');
                if (dactive > -1)
                    result += ' active';
                break;
            }
        return result;
    }

    const goTo = (path: string) => {
        if (path !== '') {
            if (id) navigate(path + id);
        } else {
            if (currentCourse) {
                const isMobile = isMobileApp();
                const target = isMobile ? '_self' : '_blank';
                window.open('https://www.google.com', target)
            }
        }

    }

    return (
      <div className={`${className}`}>
        <div className="menu-items">
          <div className={isActive("timeline")} onClick={() => goTo("/my-campus/course/timeline/")}>
            <EventIcon sx={{ fontSize: iconSize }} />
            <span className="mx-2">Course Timeline</span>
          </div>
          <div className={isActive("library")} onClick={() => goTo("/my-campus/course/library/")}>
            <BookIcon sx={{ fontSize: iconSize }} /> {/* Book Icon */}
            <span className="mx-2">Course Library</span>
          </div>
          <div className={isActive("discussion")} onClick={() => goTo("")}>
            <MessageIcon sx={{ fontSize: iconSize }} /> {/* Message Icon */}
            <span className="mx-2">Discussion</span>
          </div>
        </div>
      </div>
    );
}